import React, {Component} from 'react'
import TSubmitButtonForm from "../../../../common/TSubmitButtonForm";
import * as SaveStatus from "../../../../../constants/SaveStatus";
import TInputForm from "../../../../common/TInputForm";
import autobind from "autobind-decorator";
import { isValidDomainHost } from '../../../../../utils/formatter'
import {jsonResponseHandler} from "../../../../../utils/FetchHelper";
import {changeCustomDomain} from '../../../../../actions/setting/blog'
import { connect } from "react-redux";

@connect(state => ({
    address: state.setting.blog.address
}), dispatch => ({
    handleChangeCustomDomain(customDomain, certStatus, dnsFailDetected) {
        dispatch(changeCustomDomain(customDomain, certStatus, dnsFailDetected))
    },
    dispatch
}))
class RegisterCustomDomainForm extends Component {

    constructor(props, context) {
        super(props, context)

      this.state = Object.assign({
            saveStatus: SaveStatus.READY,
            customDomain : '',
            errorMessage : '',
        })
    }

    @autobind
    cancelRegisterCustomDomainForm() {
      const { closeRegisterForm } = this.props

      this.setState({
        saveStatus: SaveStatus.READY,
        customDomain: '',
        errorMessage: ''
      })
      closeRegisterForm()
    }

    @autobind
    handleChangeCustomDomainName(customDomain) {
		  this.setState({
			  customDomain: customDomain,
        errorMessage : ''
		  })
	  }

	  @autobind
    handleRegisterCustomDomain() {
        const {dispatch, handleChangeCustomDomain} = this.props;
        const {customDomain} = this.state

        this.setState({
            saveStatus: SaveStatus.DOING
        })


        fetch("/manage/setting/blog/customDomain.json", {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                customDomain: customDomain
            })
        })
            .then(jsonResponseHandler(dispatch, true))
            .then(r => r.json())
            .then(data => {

              handleChangeCustomDomain(data.customDomain, data.certStatus, data.dnsFailDetected)
              this.cancelRegisterCustomDomainForm()
            })
            .catch(r => {
              r.json().then(json => { if(json.message) this.setState({
                    errorMessage: json.message
                  })
              });

              this.setState({
                saveStatus: SaveStatus.CAN_SUBMIT
              })
            })
    }

	  @autobind
    isChangedAndValid() {

      const { customDomain } = this.state

      if( customDomain !== ''  && isValidDomainHost(customDomain)){
        return true
      }

      return false
    }

    render() {

      const { saveStatus, customDomain, errorMessage } = this.state

      let needSave = this.isChangedAndValid()
        let status = saveStatus
        if (saveStatus !== SaveStatus.DOING && needSave) {
            status = SaveStatus.CAN_SUBMIT
        }

        return [

            <fieldset className="fld_domain" key="registerFormTop">
              <legend className="screen_out">개인 도메인 설정</legend>
              <div className="item_set">
                가비아, 후이즈 등 도메인 등록 업체에서 구입한 도메인을 연결할 수 있습니다.
              </div>
              <div className="item_set">
                <div className="bunddle_domain">
                  <label className="lab_tf">
                    <span className="screen_out">개인 도메인 설정</span>
                    <span className="txt_http">http://</span>
                    <TInputForm type="text" className={"tf_blog tf_address1"} value={customDomain} onChange={this.handleChangeCustomDomainName} />
                  </label>
                  <ul className="list_set">
                    <li>DNS 서비스에서 CNAME 레코드, IP 등을 먼저 설정한 후에 연결해 주세요.
                      <a href="https://notice.tistory.com/1784" className="info_sub" target="_blank">자세히 보기</a></li>
                    <li>한글 도메인으로 연결하는 경우에는 퓨니코드로 등록하시기 바랍니다.</li>
                    <li>주소 변경으로 일시적으로 방문이 줄어드는 부작용이 발생할 수 있습니다.</li>
                  </ul>
                </div>
              </div>
            </fieldset>
              ,
            <fieldset key="registerFormBottom">
                <p className="txt_required">{errorMessage}</p>
                <legend className="screen_out">저장 버튼</legend>
                <TSubmitButtonForm type="submit" status={status} onClick={this.handleRegisterCustomDomain} />
                <button type="button" className="btn_cancel" onClick={this.cancelRegisterCustomDomainForm}>취소</button>
            </fieldset>

        ]
    }
}

export default RegisterCustomDomainForm
